import { ChangeDetectionStrategy, Component, ElementRef, Input, Optional, Self, ViewChild } from '@angular/core'
import { ControlValueAccessor, NgControl } from '@angular/forms'

@Component({
  selector: 'lin-chat-message-input',
  templateUrl: './chat-message-input.component.html',
  styleUrls: ['./chat-message-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatMessageInputComponent implements ControlValueAccessor {
  @ViewChild('messageContainer', { static: true }) message: ElementRef<HTMLDivElement>
  @Input() placeholder = ''

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) this.ngControl.valueAccessor = this
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange(value: any): void {}

  onInput(eventText: string): void {
    this.onChange(eventText)
  }

  writeValue(value: string): void {
    this.message.nativeElement.innerText = value
  }

  registerOnChange(fn): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.onChange = fn
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnTouched() {}

  onPaste(event: ClipboardEvent) {
    // get and validate data from clipboard
    const value = event.clipboardData.getData('text/plain')

    event.preventDefault()

    if (this.ngControl.control.value) {
      const caretIndex = this.getCaretIndex(this.message.nativeElement)

      const isSelected = window.getSelection().anchorOffset === window.getSelection().focusOffset

      const start = isSelected ? caretIndex : window.getSelection().anchorOffset
      const end = isSelected ? caretIndex : window.getSelection().focusOffset

      const currentValue = <string>this.ngControl.control.value
      const updatedValue = [currentValue.slice(0, start), value, currentValue.slice(end)].join('')

      this.ngControl.control.setValue(updatedValue)
    } else {
      this.ngControl.control.setValue(value)
    }

    setTimeout(this.moveCaretToEnd, 0)
  }

  private getCaretIndex = (element: HTMLElement): number => {
    let position = 0
    const isSupported = typeof window.getSelection !== 'undefined'
    if (isSupported) {
      const selection = window.getSelection()
      if (selection.rangeCount !== 0) {
        const range = window.getSelection().getRangeAt(0)
        const preCaretRange = range.cloneRange()
        preCaretRange.selectNodeContents(element)
        preCaretRange.setEnd(range.endContainer, range.endOffset)
        position = preCaretRange.toString().length
      }
    }

    return position
  }

  private moveCaretToEnd = () => {
    const el = this.message.nativeElement
    const selection = window.getSelection()
    const range = document.createRange()

    selection.removeAllRanges()
    range.selectNodeContents(el)
    range.collapse(false)
    selection.addRange(range)
    el.focus()
  }
}
